import { Typography } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { DialogModal } from '@/components/modals/DialogModal/DialogModal';

interface IntegrationUserSetupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  providerName: string;
}

export function IntegrationUserSetupModal({
  isOpen,
  onClose,
  onContinue,
  providerName,
}: IntegrationUserSetupModalProps) {
  return (
    <DialogModal
      isOpen={isOpen}
      onClose={onClose}
      dialogContentSx={{ maxWidth: '500px' }}
      heading="Setting up your integration user"
      actions={
        <Button variant="primary" size="sm" onClick={onContinue} fullWidth>
          Continue
        </Button>
      }
    >
      <Typography variant="body-s" component="ol" sx={{ pl: 2 }}>
        <li style={{ marginBottom: '5px' }}>
          Open {providerName} in a new tab and ensure you&apos;re logged out of
          your personal user account.
        </li>
        <li style={{ marginBottom: '5px' }}>Return to this screen.</li>
        <li style={{ marginBottom: '5px' }}>
          Click &quot;Continue&quot;, and enter the integration user credentials
          when prompted.
        </li>
        <li style={{ marginBottom: '5px' }}>
          After connecting, open {providerName} in a new tab again and switch to
          your personal account. (This will entail logging out of the
          integration user account and logging back in with your personal
          credentials.)
        </li>
      </Typography>
    </DialogModal>
  );
}
